<template>
  <div class="order-detail" v-if="isShow" @click="isShow = false">
    <div class="main" @click.stop="isShow = true">
      <div
        style="width: 100%; height: 100%; padding: 24px; box-sizing: border-box; display: flex; flex-direction: column; gap: 16px;">
        <div style="display: flex; align-items: center; gap: 16px;">
          <div v-if="orderInfo.orderStatus == 0"
            style="width: 58px;height: 24px;background: #FC811E;border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 14px;">
            {{ $t('personal.pending_payment') }}
          </div>
          <div v-else
            style="width: 58px;height: 24px;background: #1AB07F;border-radius: 4px; display: flex; justify-content: center; align-items: center; color: #fff; font-size: 14px;">
            {{ $t('personal.paid') }}</div>

          <div style="font-size: 20px; font-weight: bold; color: #333;" v-if="orderInfo.orderNo">{{ orderInfo.orderNo }}
          </div>
          <div style="flex: 1;"></div>
          <div v-if="orderInfo.orderStatus == 0"
            style="font-size: 14px; color: #333333; display: flex;align-items: center;">
            <div>{{ $t('personal.remaining_payment_time') }}</div>
            <el-countdown format="HH:mm:ss" :value="getEndTime(orderInfo.expireTime)" />
          </div>
          <div v-else style="color: #333; font-size: 14px; font-weight: 400;">{{ $t('personal.payment_time') }}{{ orderInfo.expireTime }}</div>
        </div>
        <div
          style="border-radius: 4px; padding: 24px; display: flex; flex-direction: column; gap: 16px; border: 1px solid #CCCCCC;">
          <div style="display: flex; gap: 16px; align-items: flex-start;">
            <div
              style="width: 100px; height: 100px; border-radius: 4px; position: relative; background-color: #F2F2F2; display: flex; justify-content: center; align-items: center;">
              <img v-if="orderInfo.designImageDtoList.length > 0" style="max-width: 100%; max-height: 100%; width: auto; height: auto;"
                :src="orderInfo.designImageDtoList[0].previewUrl">
              <img v-else style="max-width: 100%; max-height: 100%; width: auto; height: auto;" :src="orderInfo.orderItems[0].itemFileUrl[0]" alt="">
             
              <!-- <img style="width: 100%" :src="orderInfo.orderItems[0].itemFileUrl[0]">
              <img :src="orderInfo.designImageDtoList[0].artUrl"
                style="width: 40px; position: absolute; left: 50%; transform: translate(-50%,-50%); top:50%;" alt=""> -->
            </div>
            <div style="flex: 1; display: flex; flex-direction: column;">
              <div style="font-size: 16px; color: #333; font-weight: 400;">{{ orderInfo.customDesignName }}</div>
              <div style="font-size: 14px; color: #333; font-weight: 400; margin-top: 20px;">{{
                orderInfo.orderItems[0].itemName }}</div>
              <div style="color: #333; font-size: 12px; margin-top: 20px;">{{ $t('personal.quantity') }}{{ orderInfo.orderItems[0].itemQuantity }}
              </div>
            </div>
            <div style="color: #F91F1F; font-size: 18px; font-weight: bold; margin-top: 70px;">￥{{ orderInfo.totalAmount
            }}</div>
          </div>
          <div style="width: 700px;height: 1px;background: #CCCCCC;border-radius: 1px;"></div>
          <div style="display: flex;">
            <div style="display: flex; flex-direction: column; align-items: center; margin-right: 20px;">
              <div
                style="width: 160px; height: 160px; border-radius: 4px; background: #F2F2F2; display: flex; justify-content: center; align-items: center;">
                <img :src="orderInfo.orderItems[0].itemFileUrl[0]"
                  style="max-width: 100%; max-height: 100%; width: auto; height: auto;" />
              </div>
              <div style="color: #333; font-size: 14px; margin-top: 8px;">{{ orderInfo.orderItems[0].itemName }}</div>
              <!-- <div style="color: #333; font-size: 14px;">￥{{orderInfo.orderItems[0].itemPrice}}</div> -->
            </div>
            <div style="display: flex; flex-direction: column; align-items: center;  margin-right: 20px;"
              v-for="(item, i) in orderInfo.designImageDtoList">
              <div style="width: 160px; height: 160px; border-radius: 4px; background: #F2F2F2;">
                <img :src="item.artUrl ? item.artUrl : item.localImageUrl"
                  style="max-width: 100%; max-height: 100%; width: auto; height: auto;" />
              </div>
              <div style="color: #333; font-size: 14px; margin-top: 8px;">
                {{ item.imageLocation == 1 ? $t('personal.front_print') : item.imageLocation == 2 ? $t('personal.front_left_chest_print') : item.imageLocation ==
                3 ? $t('personal.back_print') : '' }} </div>
              <!-- <div style="color: #333; font-size: 14px;">￥1</div> -->
            </div>
          </div>
        </div>
        <div v-if="orderInfo.orderStatus == 10"
          style="border: 1px solid #CCCCCC; border-radius: 4px; padding: 20px; display: flex; flex-direction: column;">
          <div style="display: flex; align-items: center; gap: 32px;">
            <div style="color: #333; font-size: 14px;">{{ $t('personal.recipient') }}{{ addrInfo.receiver }}</div>
            <div style="color: #333; font-size: 14px; margin-left: 100px;">{{ $t('personal.mobile') }}{{ addrInfo.mobile }}</div>
          </div>
          <div style="color: #333; font-size: 14px; margin-top: 10px;">{{ $t('personal.address_info') }}{{ addrInfo.province }}{{ addrInfo.city }}{{
            addrInfo.area }}{{ addrInfo.street }}</div>
          <div style="color: #333; font-size: 14px; margin-top: 10px;">{{ $t('personal.detailed_address') }}{{ addrInfo.addr }}</div>
        </div>
        <div v-if="orderInfo.orderStatus == 10"
          style="border: 1px solid #CCCCCC; border-radius: 4px; padding: 20px; display: flex; align-items: center;">
          <div style="color: #333; font-size: 14px;">{{ $t('personal.payment_method') }}</div>
          <!-- <div style="color: #333; font-size: 14px; margin-left: 150px;">回执单号：HZ23905066666</div> -->
        </div>
      </div>
      <div v-if="orderInfo.orderStatus == 0" style="position: absolute; right: 22px; bottom: 20px;">
        <el-button style="width: 100px;height: 36px;" @click="cancelOrder(orderInfo)">{{ $t('personal.cancel_order') }}</el-button>
        <el-button @click="pay(orderInfo)" color="#020468"
          style="margin-left: 10px;width: 100px;height: 36px;">{{ $t('personal.pay') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { onBeforeUnmount, onMounted, ref, watch } from "vue";
import { getAliPay, getAliPayState, cancelOrderById, getOrderDetail } from "@/api/api";
import router from "@/router";
import { ElMessage } from "element-plus";
import { useI18n } from 'vue-i18n';
export default {
  name: 'orderDetail',
  components: {
  },
  setup(props, { emit }) {
    const { t } = useI18n();
    const isShow = ref(false)
    const orderInfo = ref({ orderStatus: null })
    const addrInfo = ref({})
    const show = (item) => {
      console.log("item", item)
      orderInfo.value = item
      isShow.value = true
      getOrderDetail(item.orderId).then(res => {
        console.log("res", res)
        addrInfo.value = res.addrInfo
      })
    }
    onMounted(() => {

    })

    const getEndTime = (time) => {
      return new Date(time).getTime()
    }

    const payCallBackTime = ref(null)

    // 在组件卸载前关闭定时器
    onBeforeUnmount(() => {
      if (payCallBackTime.value) {
        clearInterval(payCallBackTime.value);
        payCallBackTime.value = null; // 避免重复清除
      }
    });

    const cancelOrder = (item) => {
      cancelOrderById(item).then(res => {
        ElMessage.success(t('personal.operation_success'))
        isShow.value = false
        emit("cancelOrder")
      })
    }

    const pay = (res) => {
      getAliPay({
        orderNo: res.orderNo
      }).then(res => {
        const div = document.createElement('div')
        div.innerHTML = res.payBody
        document.body.appendChild(div)
        // document.forms[0].target = '_blank'
        document.forms[0].submit()
        div.innerHTML = ''
      }).catch(err => { })

      //循环查询订单支付状态
      payCallBackTime.value = setInterval(() => {
        getAliPayState({ orderNo: res.orderNo }).then((res) => {
          console.log(res)
          if (res.payStatus === 20) {
            console.log(t('personal.payment_success'))
            clearInterval(payCallBackTime.value)
            router.push({ path: `/` });
            ElMessage.success(t('personal.payment_success'));
          } else if (res.payStatus === 50) {
            console.log('已退款')
            clearInterval(payCallBackTime.value)
            router.push({ path: `/` });
          }
        });
      }, 2000)
    }
    return {
      addrInfo,
      pay,
      cancelOrder,
      getEndTime,
      orderInfo,
      show,
      isShow,
    }
  }
}

</script>
<style lang="scss" scoped>
.order-detail {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;

  .main {
    width: 800px;
    height: 800px;
    background: #FFFFFF;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    position: relative;
  }
}
</style>
